import KeywordRule from './KeywordRule'

export default KeywordRule
